
export const walletNotInstalledMessage = (
  <p>
    {' '}
    🦊{' '}
    <a target='_blank' rel='noreferrer' href='https://metamask.io/download.html'>
      You must install Metamask, a virtual Ethereum wallet, in your
      browser.
    </a>
  </p>
)
